import React from "react";
import { connect } from "react-redux";
import {
  NumberField,
  FunctionField,
  TabbedShowLayout,
  SelectInput,
  ReferenceField,
  TextField,
  Show,
  Tab,
  ReferenceManyField,
  Datagrid,
  DateField,
  ShowButton,
  Filter,
  TextInput,
  DateInput,
  Button,
  Link,
  List,
  Pagination,
  CardActions,
  EditButton,
  GET_LIST,
  GET_ONE,
  Query,
  downloadCSV,
  showNotification,
} from "react-admin";

import {
  isEmpty,
  propEq,
  prop,
  filter,
  head,
  sum,
  map,
  path,
  isNil,
} from "ramda";
import * as R from "ramda" 
import { TextBooleanField } from "../../components/TextBooleanField";
import { PersonalInformationField } from "../../components/PersonalInformationField";
import CreateChargeTourButton from "../../components/createChargeTour";
import moment from "moment";
import { parse } from "query-string";

import styled from "styled-components";
import moment_tz from 'moment-timezone';
import { DATEFORMAT } from "../../date-config";
import {CustomizedTables} from "../../components/resumenPayments"
import dataProviderFactory from "../../dataProvider";
import { useState, useEffect, useCallback } from "react";
import Grid from "@material-ui/core/Grid";
import CircularProgress from '@material-ui/core/CircularProgress';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import AccountBalanceIcon from '@material-ui/icons/AccountBalance';
import MessageIcon from '@material-ui/icons/Message';
import PersonPin from "@material-ui/icons/PersonPin"; //vip
import Navigation from "@material-ui/icons/Navigation"; //gps
import BeachAccess from "@material-ui/icons/BeachAccess"; //cancel
import PostAddIcon from '@material-ui/icons/PostAdd'; //documents

import EventSeat from "@material-ui/icons/EventSeat"; //low seat
import LocalGasStation from "@material-ui/icons/LocalGasStation"; //tankbags
import Pantool from "@material-ui/icons/PanTool"; //gloves
import Face from "@material-ui/icons/Face"; //helments
import Polymer from "@material-ui/icons/Polymer"; //jackets

import {PaymentsClients} from "../../components/boxPaymentsClients"
import { canAccess } from "../../rbac";
import { getCountryByID, getNationality, duration } from "../../util";

import { 
  StyledExPanel, 
  ImgContainer, 
  Marker, 
  StyledTypo, 
  BorderContainer,
  StyledCard,
  LoaderContainer,
  StyledExpansionSummary,
  StyledPanelDetails,
  BordedBox,
  ClientImgContainer,
  RiderImageContainer,
  RiderHeaderTable,
  RiderTableInfo,
  IconBox,
} from "../styles/tourClients/style";

import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardMedia from '@material-ui/core/CardMedia';
import CardContent from '@material-ui/core/CardContent';
import passenger_bg from "../../assets/img/passenger_bg.png" ;
import rider_bg from "../../assets/img/rider_bg.png" ;
import visa from "../../assets/img/visa.svg" ;
import mastercard from "../../assets/img/mastercard.svg" ;
import roomate_bg from "../../assets/img/roomate_bg.png" ;
import vip from "../../assets/img/vip.png" ;
import gps from "../../assets/img/gps.png" ;
import documents from "../../assets/img/documents.png" ;
import cancelation from "../../assets/img/cancelation.png" ;

import { TourNavigation, TourBreadcrumb, QuickTourLinks } from "../../components/TourNavigation";

window.R = R

// ============================================================================
// CONSTANTES Y CONFIGURACIONES
// ============================================================================

const CARD_ACTION_STYLE = {
  zIndex: 2,
  display: "inline-block",
  float: "right",
};

const SHIRT_SIZE_MAP = { 
  1: "S (EU) | XS (US)",
  2: "M (EU) | S (US)",
  3: "L (EU) | M (US)",
  4: "XL (EU) | L (US)",
  5: "XXL (EU) | XL (US)",
  6: "XXXL (EU) | XXL (US)" 
};

const BASES = [
  { _id: 1, description: "Barcelona" },
  { _id: 2, description: "Bilbao" },
  { _id: 3, description: "Lisbon" },
  { _id: 4, description: "Madrid" },
  { _id: 5, description: "Malaga" },
  { _id: 6, description: "Santiago" },
  { _id: 8, description: "Valencia" },
];

const ICON_CONFIG = {
  documents: { icon: PostAddIcon, label: "Docs" },
  cancel: { icon: BeachAccess, label: "Cancel" },
  vip: { icon: PersonPin, label: "Vip" },
  gps: { icon: Navigation, label: "GPS" },
  lowSeat: { icon: EventSeat, label: "Low seat" },
  tankbags: { icon: LocalGasStation, label: "tankbags" },
  gloves: { icon: Pantool, label: "gloves" },
  helmets: { icon: Face, label: "Helments" },
  jackets: { icon: Polymer, label: "Jackets" },
};

moment_tz.tz.setDefault("Europe/Madrid");

// ============================================================================
// COMPONENTES ESTILIZADOS
// ============================================================================

const StyledDiv = styled.div((props) => ({
  flexDirection: "column",
  alignItems: props.align ? props.align : "center",
  justifyContent: props.justify ? props.justify : "center",
  backgroundColor: props.color,
  paddingTop: props.padding ? props.padding : "0px",
  paddingBottom: props.padding ? props.padding : "0px",
  minHeight: "40px",
  display: "flex",
  minWidth: "100px",
}));

// ============================================================================
// HOOKS PERSONALIZADOS
// ============================================================================

// Hook para cachear datos de bookings
const useBookingsCache = () => {
  const [bookingsCache, setBookingsCache] = useState(new Map());
  
  const getBookingData = useCallback(async (bookingId) => {
    if (bookingsCache.has(bookingId)) {
      return bookingsCache.get(bookingId);
    }
    
    // Si no está en cache, hacer la consulta
    const dataProvider = await dataProviderFactory("rest");
    const booking = await dataProvider(GET_ONE, "bookings", { id: bookingId });
    
    // Guardar en cache
    setBookingsCache(prev => new Map(prev).set(bookingId, booking.data));
    return booking.data;
  }, [bookingsCache]);
  
  return { getBookingData, bookingsCache };
};

const useTourData = () => {
  const [tourData, setTourData] = useState("");
  const [storedRecord, setStoredRecord] = useState(null);
  const [dataCountrys, setDataCountrys] = useState(null);
  const [clientCountry, setClientCountry] = useState(null);
  const [bankInfo, setBankInfo] = useState({type: "", account: ""});
  const [comments, setComments] = useState([]);

  const getCountrys = async () => {
    const dataProvider = await dataProviderFactory("rest");
    const countries = await dataProvider(GET_LIST, "countries", {
      pagination: { page: 1, perPage: 1000 },
      filter: { },
      sort: { field: "country", order: "ASC" },
    });
    return countries;
  };

  const getTourPrice = async (tour) => {
    const priceDate = tour.booking.price_date;
    const tour_id = tour.booking.tour_id;
    const dataProvider = await dataProviderFactory("rest");
    
    const vehicleModels = await dataProvider(GET_LIST, "vehicle_models", {
      filter: { active: true, type: "2_2" },
      pagination: { page: 1, perPage: 99999 },
      sort: { field: "order", order: "ASC" }
    });

    const responseTourPrices = await dataProvider(GET_LIST, "prices", {
      filter: { for_date: priceDate, for_tour_id: tour_id },
      pagination: { page: 1, perPage: 99999 },
      sort: {}
    });

    let passengerPrice = 0;
    let singlePrice = 0;
    let tourTotal = 0;

    if(!isNil(tour.booking.p_first_name)){
      passengerPrice = prop(
        "price",
        head(filter(propEq("price_item_sub_type", "tour_passenger"), responseTourPrices.data))
      );
    }
    
    if((tour.single.length > 0) && (tour.r_single || tour.booking.r_single)){
      singlePrice = prop(
        "price",
        head(filter(propEq("price_item_sub_type", "tour_single"), responseTourPrices.data))
      );
    }
    
    if (tour.vehicle.length > 0) {
      tourTotal = prop(
        "price",
        head(filter(propEq("price_item_sub_type", "tour_total"), responseTourPrices.data))
      );      
    } else {
      tourTotal = 500 + prop(
        "price",
        head(filter(propEq("price_item_sub_type", "tour_passenger"), responseTourPrices.data))
      );
    }
    
    return {tourTotal, passengerPrice, singlePrice, prices: responseTourPrices, models: vehicleModels};
  };

  const fetchTourData = async (record) => {
    if (!record) return;
    
    const result = await getTourPrice(record); 
    const countries = await getCountrys();
    
    setDataCountrys(countries.data);
    setTourData(result);
    setClientCountry(getCountryByID(countries.data, record.booking.r_country_id, "Not found"));
    
    // Procesar información bancaria
    if(record.clientData && record.clientData.startsWith("visa -")){
      setBankInfo({type: "visa", account: record.clientData.replace("visa -", "")});
    } else if(record.clientData && record.clientData.startsWith("mastercard -")){
      setBankInfo({type: "mastercard", account: record.clientData.replace("mastercard -", "")});
    }
    
    // Procesar comentarios
    if(record.imt_comment){
      setComments(record.imt_comment.split('/**'));
    }
  };

  return {
    tourData,
    storedRecord,
    dataCountrys,
    clientCountry,
    bankInfo,
    comments,
    setStoredRecord,
    fetchTourData
  };
};

// ============================================================================
// COMPONENTES AUXILIARES
// ============================================================================

const ToursDueShowTitle = ({ record }) => (
  <span>
    {" Tour detail for Client "} &quot;
    {`${record.booking.r_first_name} ${record.booking.r_last_name}`}
    &quot;
  </span>
);

const ToursDueShowActions = ({ data, redirect, permissions, props }) => {
  const from = props.location;
  
  return (
    <CardActions style={CARD_ACTION_STYLE}>
      <Button
        component={Link}
        to={{ pathname: `/${redirect}` }}
        label="Go Back"
      />
      {data && data.rental_status !== 3 &&
        canAccess("tour_due_list") && (
          <EditButton
            to={{
              pathname: `/process_tour_enhanced/${data.id}`,
              search: `${from.search}`,
            }}
            label="Edit"
          />
        )}
    </CardActions>
  );
};

const LoadingSpinner = () => (
  <LoaderContainer>
    <CircularProgress size="3.5rem" />
  </LoaderContainer>
);

const IconCard = ({ isAvailable, icon: Icon, label }) => (
  <StyledCard className={isAvailable ? "available" : "no-available"}>
    <Grid 
      container 
      direction="column" 
      justify="center"
      alignItems="center"
      spacing={0} 
      style={{ marginTop: "10px" }}
    >
      <Icon style={{transform: "scale(1)"}} />
      <StyledTypo style={{textAlign:"center"}} className="bold">{label}</StyledTypo>
    </Grid>
  </StyledCard>
);

const IconGrid = ({ icons, storedRecord }) => (
  <IconBox>
    <Grid 
      container 
      spacing={24} 
      direction="row"
      justify="center"
      style={{ marginTop: "10px" }}
    >
      {icons.map(({ key, config }) => (
        <Grid item xs={0} key={key}>
          <IconCard 
            isAvailable={storedRecord[key] && storedRecord[key][0]}
            icon={config.icon}
            label={config.label}
          />
        </Grid>
      ))}
    </Grid>
  </IconBox>
);

const InfoField = ({ label, value }) => (
  <BordedBox>
    <Grid container direction="column" spacing={0} style={{ marginTop: "7px" }}>
      <StyledTypo className="header">{label}</StyledTypo>
      <StyledTypo className="bold">{value}</StyledTypo>
    </Grid>
  </BordedBox>
);

const InfoRow = ({ fields }) => (
  <Grid 
    container 
    direction="row" 
    justify="space-between" 
    spacing={8} 
    style={{ marginTop: "10px" }}
  >
    {fields.map(({ label, value }, index) => (
      <Grid item xs={6} key={index}>
        <InfoField label={label} value={value} />
      </Grid>
    ))}
  </Grid>
);

const ClientHeader = ({ imageSrc, title, name, location, className = "" }) => (
  <RiderHeaderTable className={className}>
    <Grid container alignItems="center" spacing={0}>
      <Grid item xs={0}>
        <RiderImageContainer className={className}>
          <ClientImgContainer src={imageSrc} />
        </RiderImageContainer>
      </Grid>
      <Grid item xs={0}>
        <Grid container direction="column" spacing={0} style={{ marginTop: "10px" }}>
          <div>
            <StyledTypo className="pill-primary">{title}</StyledTypo>
          </div>
          <StyledTypo style={{textTransform: "capitalize", color:"#fff"}} className="big">
            {name}
          </StyledTypo>
          <div>
            <StyledTypo className="pill-secondary textCapi">{location}</StyledTypo>
          </div>
        </Grid>
      </Grid>
    </Grid>
  </RiderHeaderTable>
);

const ClientInfoSection = ({ client, dataCountrys, clientCountry, shirtSize }) => {
  const renderHeightUnit = (rental) => {
    const unitField = rental.booking.r_height_unit;
    return unitField === 1 || unitField === '1' ? "Ft" : "M";
  };

  const renderWeightUnit = (rental) => {
    const unitField = rental.booking.r_weight_unit;
    return unitField === 1 || unitField === '1' ? "Pounds" : "Kg";
  };

  const getLanguages = (booking) => {
    const languages = [];
    if (booking.r_english) languages.push("English");
    if (booking.r_spanish) languages.push("Spanish");
    if (booking.r_german) languages.push("German");
    if (booking.r_portuguese) languages.push("Portuguese");
    return languages.join(" ");
  };

  const infoFields = [
    { label: "Full name", value: `${client.booking.r_first_name} ${client.booking.r_last_name}` },
    { label: "Email", value: client.booking.r_email },
    { label: "Country", value: clientCountry },
    { label: "City", value: client.booking.r_city },
    { label: "Address", value: client.booking.r_address },
    { label: "ZIP code", value: client.booking.r_zip },
    { label: "Phone", value: client.booking.r_home_phone || "Not found" },
    { label: "Occupation", value: client.booking.r_occupation || "N/A" },
    { label: "Passport / ID", value: client.booking.r_passport },
    { label: "Nationality", value: getNationality(dataCountrys, client.booking.r_nationality) },
    { label: "Date of birth", value: moment.utc(client.booking.r_birthday).format("MMMM D, YYYY") },
    { label: "Age", value: `${moment.utc().diff(moment.utc(client.booking.r_birthday), "years")} Years old` },
    { label: "Weight", value: `${client.booking.r_weight} ${renderWeightUnit(client)}` },
    { label: "Height", value: `${client.booking.r_height} ${renderHeightUnit(client)}` },
    { label: "T-shirt size", value: client.booking.r_shirt ? prop(client.booking.r_shirt, shirtSize) : "N/A" },
    { label: "Languages", value: getLanguages(client.booking) },
  ];

  return (
    <div style={{display:"block", padding:"1rem"}}>
      {infoFields.map((field, index) => (
        <InfoField key={index} label={field.label} value={field.value} />
      ))}
    </div>
  );
};

const BankInfoSection = ({ bankInfo }) => (
  <RiderHeaderTable style={{ marginTop: "15px" }} className="secondary">
    <Grid container alignItems="center" spacing={0}>
      <Grid item xs={0}>
        <RiderImageContainer className="secondary">
          <AccountBalanceIcon style={{transform: "scale(1.8)", color: "white"}}/>
        </RiderImageContainer>
      </Grid>
      <Grid item xs={0}>
        <Grid container direction="column" justify="center" spacing={0} style={{ marginTop: "10px" }}>
          <div>
            <StyledTypo className="pill-primary">Bank information</StyledTypo>
          </div>
          <Grid container justify="center" alignItems="center" spacing={0}>
            <img 
              src={bankInfo.type === "visa" ? visa : mastercard} 
              style={{width:"50px", marginRight:"10px"}}
            />
            <StyledTypo style={{color: "rgb(51,56,62)"}} className="medium">
              {bankInfo.account}
            </StyledTypo>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  </RiderHeaderTable>
);

const CommentsSection = ({ comments }) => (
  <RiderHeaderTable style={{ marginTop: "15px" }} className="secondary">
    <Grid container alignItems="center" spacing={0}>
      <Grid item xs={0}>
        <RiderImageContainer className="secondary">
          <MessageIcon style={{transform: "scale(1.8)", color: "white"}}/>
        </RiderImageContainer>
      </Grid>
      <Grid item xs={0}>
        <Grid container direction="column" justify="center" spacing={0} style={{ marginTop: "10px" }}>
          <div>
            <StyledTypo className="pill-primary">Comments</StyledTypo>
          </div>
          {comments.length > 0 ? 
            comments.map((comment, index) => (
              <StyledTypo 
                key={index}
                style={{color: "rgba(0, 0, 0, 0.54)", maxWidth: "390px"}}
              >
                {comment}
              </StyledTypo>
            ))
            :
            <StyledTypo style={{color: "rgba(0, 0, 0, 0.54)"}} className="medium">
              no comments
            </StyledTypo>
          }
        </Grid>
      </Grid>
    </Grid>
  </RiderHeaderTable>
);

const PassengerSection = ({ storedRecord, clientCountry, dataCountrys, shirtSize }) => {
  const firstPassenger = head(storedRecord.passenger || []);
  const hasPassengerLinked = firstPassenger && firstPassenger.client_first_name;
  const hasPassengerNominal =
    storedRecord.booking &&
    storedRecord.booking.p_first_name &&
    String(storedRecord.booking.p_first_name).trim() !== "";
  if (!hasPassengerLinked && !hasPassengerNominal) return null;

  return (
    <StyledExPanel>
      <StyledExpansionSummary
        expandIcon={<ExpandMoreIcon style={{color: "#fff"}}/>}
        aria-controls="panel1a-content"
        id="panel1a-header"
      >   
        <ClientHeader
          imageSrc={passenger_bg}
          title="Passenger"
          name={`${storedRecord.booking.p_first_name} ${storedRecord.booking.p_last_name}`}
          location={`${storedRecord.booking.p_city}, ${clientCountry}`}
        />
      </StyledExpansionSummary>
      <StyledPanelDetails style={{display:"block"}}>
        <ClientInfoSection 
          client={storedRecord} 
          dataCountrys={dataCountrys} 
          clientCountry={clientCountry}
          shirtSize={shirtSize}
          isPassenger={true}
        />
      </StyledPanelDetails>
    </StyledExPanel>
  );
};

const RoommateSection = ({ storedRecord }) => {
  const hasPassenger = storedRecord.booking &&
    storedRecord.booking.p_first_name &&
    String(storedRecord.booking.p_first_name).trim() !== "";
  const roommateName = storedRecord.booking
    ? String(storedRecord.booking.roommate || "").trim()
    : "";
  if (hasPassenger || !roommateName) return null;

  return (
    <ClientHeader
      imageSrc={roomate_bg}
      title="Roomate"
      name={storedRecord.booking.roommate}
      location=""
    />
  );
};

// ============================================================================
// UTILIDADES PARA ENLACES
// ============================================================================

// Función para generar enlaces a tours específicos
export const generateTourClientLink = (tourId) => `/tour_clients/${tourId}/show`;

// Función para generar enlaces a tours due
export const generateToursDueLink = () => `/tour_due_list`;

// Componente de enlace personalizado
const TourClientLink = ({ tourId, children, ...props }) => (
  <Link to={generateTourClientLink(tourId)} {...props}>
    {children}
  </Link>
);

// Componente de botón de enlace
const TourClientButton = ({ tourId, label = "Ver Detalles", ...props }) => (
  <Button
    component={Link}
    to={generateTourClientLink(tourId)}
    label={label}
    {...props}
  />
);

// ============================================================================
// COMPONENTE PRINCIPAL REFACTORIZADO
// ============================================================================

export const ToursDueShow = ({ permissions, ...props }) => {
  const from = parse(props.location.search).from || null;
  const redirect = from ? from : "tour_list";
  
  const {
    tourData,
    storedRecord,
    dataCountrys,
    clientCountry,
    bankInfo,
    comments,
    setStoredRecord,
    fetchTourData
  } = useTourData();

  useEffect(() => {
    if (storedRecord) {
      fetchTourData(storedRecord);
    }
  }, [storedRecord]);

  const handleStoredRecord = (record) => {
    setStoredRecord(record);
  };

  const mainIcons = [
    { key: 'r_documentacion', config: ICON_CONFIG.documents },
    { key: 'cancel_insurance', config: ICON_CONFIG.cancel },
    { key: 'insurance', config: ICON_CONFIG.vip },
    { key: 'device', config: ICON_CONFIG.gps },
  ];

  const accessoryIcons = [
    { key: 'seat', config: ICON_CONFIG.lowSeat },
    { key: 'tankbag', config: ICON_CONFIG.tankbags },
    { key: 'glove', config: ICON_CONFIG.gloves },
    { key: 'helmet', config: ICON_CONFIG.helmets },
    { key: 'jacket', config: ICON_CONFIG.jackets },
  ];

  return (
    <Show
      {...props}
      title={<ToursDueShowTitle record={props.record} />}
      actions={
        <ToursDueShowActions permissions={permissions} props={props} redirect={redirect} />
      }
    >
      {/* NUEVO: Navegación personalizada */}
      <TourNavigation 
        currentPage="tour_clients" 
        tourId={props.record && props.record.id}
        onBack={redirect}
      />
      
      {/* NUEVO: Breadcrumb */}
      <TourBreadcrumb 
        items={[
          { to: "/tour_due_list", label: "Tours Due" },
          { to: `/tour_clients/${props.record && props.record.id}/show`, label: "Detalles del Tour" }
        ]} 
      />
      
      {/* NUEVO: Enlaces rápidos */}
      {props.record && props.record.id && (
        <QuickTourLinks tourId={props.record.id} />
      )}
      
      <TabbedShowLayout>
        <Tab label="Tour Details">
          <FunctionField
            addLabel={false}
            render={(record) => handleStoredRecord(record)}
          />
          {storedRecord !== null && tourData !== "" ? (
            <Grid container spacing={24} style={{ marginTop: "10px" }}>
              <Grid item xs={4}>
                <RiderTableInfo>
                  <ClientHeader
                    imageSrc={rider_bg}
                    title="Rider"
                    name={`${storedRecord.booking.r_first_name} ${storedRecord.booking.r_last_name}`}
                    location={`${storedRecord.booking.r_city}, ${clientCountry}`}
                  />
                  <ClientInfoSection 
                    client={storedRecord} 
                    dataCountrys={dataCountrys} 
                    clientCountry={clientCountry}
                    shirtSize={SHIRT_SIZE_MAP}
                  />
                </RiderTableInfo>
              </Grid>
              
              <Grid item xs={4} justify="space-between">
                <IconGrid icons={mainIcons} storedRecord={storedRecord} />
                <IconGrid icons={accessoryIcons} storedRecord={storedRecord} />
                
                {tourData !== "" ? (
                  <PaymentsClients data={storedRecord} price={tourData} isOpen={false}/>
                ) : (
                  <CircularProgress />
                )}
                
                <PassengerSection 
                  storedRecord={storedRecord}
                  clientCountry={clientCountry}
                  dataCountrys={dataCountrys}
                  shirtSize={SHIRT_SIZE_MAP}
                />
                
                <RoommateSection storedRecord={storedRecord} />
              </Grid>
              
              <Grid item xs={4}>
                {tourData !== "" ? (
                  <CustomizedTables data={storedRecord} prices={tourData}/>
                ) : (
                  <CircularProgress />
                )}
                
                <BankInfoSection bankInfo={bankInfo} />
                <CommentsSection comments={comments} />
              </Grid>
            </Grid>
          ) : (
            <LoadingSpinner />
          )}
        </Tab>
        
        <Tab label="Payments">
          <ReferenceManyField
            label="Payments"
            reference="payments"
            target="type_id"
            filter={{ type: "rental", refund: 0 }}
          >
            <Datagrid>
              <DateField source="date" />
              <NumberField
                source="value"
                options={{ style: "currency", currency: "EUR" }}
              />
              <ShowButton label="Charges" />
              <TextField label="Comments" source="comments" />
            </Datagrid>
          </ReferenceManyField>
        </Tab>
        
        <Tab label="Extra Payments">
          <ReferenceManyField
            label="Extra Payments"
            reference="payments"
            target="type_id"
            filter={{ type: "extra_charge", refund: 0 }}
          >
            <Datagrid>
              <DateField source="date" />
              <NumberField
                source="value"
                options={{ style: "currency", currency: "EUR" }}
              />
              <ShowButton label="Charges" />
              <TextField label="Comments" source="comments" />
            </Datagrid>
          </ReferenceManyField>
        </Tab>
      </TabbedShowLayout>
    </Show>
  );
};

// ============================================================================
// COMPONENTES DE LISTA
// ============================================================================

const ListPagination = (props) => (
  <Pagination rowsPerPageOptions={[10, 25, 50, 100]} {...props} />
);

const ViewDetailsButton = (props) => {
  const redirectTo = props.record.type === 1 ? "tour_clients" : "rental_clients";
  
  return (
    <ShowButton
      component={Link}
      to={{
        pathname: `/${redirectTo}/${props.record.id}/show`,
        search: "?from=tour_due_list",
      }}
      label="Details"
    />
  );
};

// ============================================================================
// Componente para mostrar la información del tour
// ============================================================================

const ToursFilter = (props) => (
  <Filter {...props}>
    <SelectInput
      label="Pick-up"
      source="location_id_1"
      choices={BASES}
      optionText="description"
      optionValue="_id"
      alwaysOn
    />
    <TextInput label="Client Email" source="client_email" alwaysOn />
    <TextInput label="Client First Name" source="first_name" alwaysOn />
    <TextInput label="Client Last Name" source="last_name" alwaysOn />
    <DateInput label="Pick-up" source="date_begin" locales="es-Es" options={{ timeZone: 'UTC' }} alwaysOn />
    <DateInput label="Drop-off" source="date_end" locales="es-Es" options={{ timeZone: 'UTC' }} alwaysOn />
  </Filter>
);

// ============================================================================
// EXPORTADOR PERSONALIZADO
// ============================================================================

const toursDueExporter = (records) => {
  console.log('Records recibidos:', records);
  console.log('Primer record:', records[0]);
  
  // Función auxiliar para obtener valores seguros
  const getSafeValue = (value) => {
    if (value === null || value === undefined) return '';
    if (typeof value === 'string' || typeof value === 'number') return value;
    if (typeof value === 'boolean') return value ? 'Yes' : 'No';
    if (typeof value === 'object') {
      // Si es un objeto, intentar convertirlo a string o devolver vacío
      try {
        return JSON.stringify(value);
      } catch (e) {
        return '';
      }
    }
    return String(value);
  };

  // Función para formatear fechas
  const formatDate = (dateValue) => {
    if (!dateValue) return '';
    try {
      return moment(dateValue).format('DD/MM/YYYY');
    } catch (e) {
      return '';
    }
  };

  // Función para formatear fechas con hora
  const formatDateTime = (dateValue) => {
    if (!dateValue) return '';
    try {
      return moment(dateValue).format('DD/MM/YYYY HH:mm');
    } catch (e) {
      return '';
    }
  };

  // Función para formatear moneda
  const formatCurrency = (value) => {
    if (!value || isNaN(value)) return '';
    return `€${parseFloat(value).toFixed(2)}`;
  };

  // Función personalizada para crear y descargar CSV
  const downloadCSVCustom = (data, filename) => {
    try {
      // Crear headers
      const headers = [
        'Tour rental ID',
        'Client', 
        'Tour',
        'P4M',
        'Start Date',
        'Pick-up city',
        'Drop-off city',
        'Submitted',
        'Days to Tour',
        'Tour Price',
        'Due'
      ];

      // Crear contenido CSV
      const csvContent = [
        headers.join(','), // Header row
        ...data.map(row => 
          headers.map(header => {
            const value = row[header] || '';
            // Escapar comillas y envolver en comillas si contiene comas o comillas
            const escapedValue = String(value).replace(/"/g, '""');
            return `"${escapedValue}"`;
          }).join(',')
        )
      ].join('\n');

      // Crear blob y descargar
      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
      const link = document.createElement('a');
      
      if (link.download !== undefined) {
        const url = URL.createObjectURL(blob);
        link.setAttribute('href', url);
        link.setAttribute('download', `${filename}.csv`);
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
      }
    } catch (error) {
      console.error('Error creando CSV:', error);
      // Fallback a la función original
      downloadCSV(data, filename);
    }
  };

  // Mapear los datos para exportar solo los campos mostrados en la tabla
  const data = records.map(record => {
    console.log('Procesando record:', record);
    
    // Extraer valores de manera segura
    const id = getSafeValue(record.id);
    const clientName = getSafeValue(record.client_name);
    const tourName = getSafeValue(record.tour_name);
    const p4m = (record.booking && record.booking.p4m) ? 'Yes' : 'No';
    const startDate = formatDate(record.date_1);
    const pickupCity = getSafeValue(record.location_name_1);
    const dropoffCity = getSafeValue(record.location_name_2);
    const submitted = formatDateTime(record.r_timestamp);
    const daysToTour = record.days_to_event ? `${record.days_to_event} days` : '';
    const tourPrice = formatCurrency(record.rental_price);
    const due = formatCurrency(record.due);
    
    return {
      'Tour rental ID': id,
      'Client': clientName,
      'Tour': tourName,
      'P4M': p4m,
      'Start Date': startDate,
      'Pick-up city': pickupCity,
      'Drop-off city': dropoffCity,
      'Submitted': submitted,
      'Days to Tour': daysToTour,
      'Tour Price': tourPrice,
      'Due': due,
    };
  });

  console.log('Data procesada:', data);
  
  // Usar función personalizada de descarga
  downloadCSVCustom(data, 'tour_due_list_export');
};

// ============================================================================
// COMPONENTE PRINCIPAL REFACTORIZADO
// ============================================================================

const ToursDueListComponent = ({ showNotification, ...props }) => {
  const [refreshKey, setRefreshKey] = React.useState(0);

  // Función para recargar la lista e invalidar el caché
  const refreshList = React.useCallback(() => {
    console.log('🔄 refreshList llamado');
    // Forzar el re-render completo del componente con un nuevo key
    // Esto desmonta y vuelve a montar el componente, evitando cualquier caché
    setRefreshKey(prev => prev + 1);
  }, []);

  // Callback para manejar el resultado del cargo (éxito o error)
  const handleChargeResult = React.useCallback((result) => {
    console.log('=== handleChargeResult RECIBIDO ===');
    console.log('Result completo:', result);
    console.log('Result (stringify):', JSON.stringify(result, null, 2));
    console.log('result.success:', result && result.success);
    console.log('result.error:', result && result.error);
    console.log('result.details:', result && result.details);
    console.log('showNotification disponible:', !!(showNotification && typeof showNotification === 'function'));
    
    // Verificar si result es válido
    if (!result) {
      console.error('❌ result es null o undefined');
      if (showNotification && typeof showNotification === 'function') {
        showNotification('Error: No se recibió respuesta del servidor', "error");
      } else {
        alert('Error: No se recibió respuesta del servidor');
      }
      return;
    }
    
    // Verificar éxito (result.success debe ser explícitamente true)
    // IMPORTANTE: Solo considerar éxito si result.success === true explícitamente
    // Si result.success es false, undefined, null, o cualquier otro valor, es un error
    if (result.success === true) {
      // Operación exitosa
      console.log('✅ Procesando resultado EXITOSO');
      
      if (showNotification && typeof showNotification === 'function') {
        console.log('Llamando showNotification con mensaje de éxito');
        try {
          showNotification("Charge created with success", "info");
          console.log('✅ showNotification llamado exitosamente');
        } catch (error) {
          console.error('❌ Error al llamar showNotification:', error);
          alert('Charge created with success');
        }
      } else {
        console.log('⚠️ showNotification no disponible, usando alert');
        alert('Charge created with success');
      }
      
      // Recargar la lista después de un éxito SOLO si fue exitoso
      refreshList();
    } else {
      // Operación fallida - mostrar mensaje de la API (ej: "Status: error al crear la factura")
      console.log('❌ Procesando resultado CON ERROR');
      const errorMessage = result && result.error 
        ? (typeof result.error === 'string' ? result.error : (result.error.message || String(result.error)))
        : 'Error al procesar el pago';
      
      console.log('Mensaje de error a mostrar:', errorMessage);
      console.log('Longitud del mensaje:', errorMessage ? errorMessage.length : 0);
      console.log('Tipo de errorMessage:', typeof errorMessage);
      console.log('showNotification:', showNotification);
      console.log('typeof showNotification:', typeof showNotification);
      
      // Asegurarse de que showNotification esté disponible y sea una función
      if (showNotification && typeof showNotification === 'function') {
        console.log('🔴 Llamando showNotification con error:', errorMessage);
        try {
          // Llamar a showNotification con el mensaje de error
          showNotification(errorMessage, "error");
          console.log('✅ showNotification llamado exitosamente con error');
        } catch (error) {
          console.error('❌ Error al llamar showNotification:', error);
          console.error('Error stack:', error && error.stack);
          // Fallback: usar alert si showNotification falla
         // alert(`Error: ${errorMessage}`);
        }
      } else {
        console.log('⚠️ showNotification no disponible o no es una función');
        console.log('  showNotification:', showNotification);
        console.log('  typeof showNotification:', typeof showNotification);
        // Fallback: usar alert
       // alert(`Error: ${errorMessage}`);
      }
      
      // IMPORTANTE: NO refrescar la lista cuando hay un error
      // Solo refrescar en caso de éxito
      console.log('⚠️ No se refrescará la lista porque hubo un error');
      refreshList();
    }
    
    console.log('=== FIN handleChargeResult ===');
  }, [showNotification, refreshList]);

  // Agregar timestamp como parte del key para evitar caché del navegador
  // El key único fuerza a React a desmontar y remontar el componente completamente
  const cacheBuster = React.useMemo(() => Date.now(), [refreshKey]);
  
  return (
    <List
      {...props}
      key={`tour-due-list-${refreshKey}-${cacheBuster}`} // Key único que cambia para forzar recarga completa
      title="Tours Due List"
      resource="tour_due_list"
      filters={<ToursFilter />}
      bulkActionButtons={false}
      pagination={false}
      sort={{ field: "date_1", order: "ASC" }}
      filterDefaultValues={{ date_begin: null }}
      filter={{ type: 1 }}
      perPage={-1}
      exporter={toursDueExporter}
    >
      <Datagrid id="tours-due-table">
        <TextField label="Tour rental ID" source="id" />
        <TextField label="Client" source="client_name" />
        <TextField label="Tour" source="tour_name" />
        <ReferenceField
          label="P4M"
          source="booking_id"
          reference="bookings"
          linkType={false}
        >
          <TextBooleanField label="P4M" source="p4m" />
        </ReferenceField>

        <DateField
          label="Start Date"
          source="date_1"
          options={{
            year: "numeric",
            month: "numeric",
            day: "numeric",
          }}
        />
        
        <FunctionField
          label="Pick-up city"
          addLabel={false}
          render={(r) => (
            <StyledDiv color={r.color_1}>{r.location_name_1}</StyledDiv>
          )}
        />
        
        <FunctionField
          label="Drop-off city"
          addLabel={false}
          render={(r) => (
            <StyledDiv color={r.color_2}>{r.location_name_2}</StyledDiv>
          )}
        />

        <ReferenceField
          label="Submitted"
          source="booking_id"
          reference="bookings"
          linkType={false}
        >
          <DateField source="r_timestamp" />
        </ReferenceField>
        
        <FunctionField
          label="Days to Tour"
          source="days_to_event"
          render={(rental) => `${rental.days_to_event} days`}
        />
        
        <NumberField
          source="rental_price"
          label="Tour Price"
          options={{
            maximumFractionDigits: 2,
            style: "currency",
            currency: "EUR",
          }}
        />

        <NumberField
          source="due"
          label="Due"
          options={{
            maximumFractionDigits: 2,
            style: "currency",
            currency: "EUR",
          }}
        />

        
       {/*  <FunctionField
          label="Discount + Rewards" 
          render={(rental) => (
            <StyledDiv>
              {parseFloat(parseFloat(rental.discount, 2) + parseFloat(rental.rewards, 2)).toFixed(2)} €
            </StyledDiv>
          )}
        /> */}
      {/*   <FunctionField
          label="Due" 
          render={(rental) => (
            <StyledDiv>
              {parseFloat(parseFloat(rental.due, 2) - parseFloat(rental.discount, 2)).toFixed(2)} €
            </StyledDiv>
          )}
        /> */}

        <FunctionField
          addLabel={false}
          render={(rental) => (
            <CreateChargeTourButton
              rental={rental}
              extraCharge={false}
              history={props}
              onChargeSuccess={refreshList}
              onChargeResult={handleChargeResult}
            />
          )}
        />
        
        <ViewDetailsButton />
      </Datagrid>
    </List>
  );
};

// Conectar showNotification a Redux
export const ToursDueList = connect(
  null,
  { showNotification }
)(ToursDueListComponent); 


// WEBPACK FOOTER //
// ./src/resources/list_tours_due/toursDue.js